import { all, call, fork, put, takeLatest } from "@redux-saga/core/effects";
import { message } from "antd";

import {
  FETCH_BARCODE_DATA_REQUEST,
} from "constants/barcode";

import {
  fetchBarcodeDataFailure,
  fetchBarcodeDataSuccess,
} from "redux/actions/Barcode";

import Barcode from "services/Barcode";

export function* onFetchBarcodeData() {
  yield takeLatest(FETCH_BARCODE_DATA_REQUEST, function* (payload) {
    try {
      const result = yield call(Barcode.getBarcodeData, payload.payload);
      if (result.status) {
        yield put(fetchBarcodeDataSuccess(result.data));
      } else {
        yield put(fetchBarcodeDataFailure(result.message));
      }
    } catch (error) {
      yield put(fetchBarcodeDataFailure(error.message));
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(onFetchBarcodeData),
  ]);
}
